// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","assistance":"_1HSmwjtlxF5BA_yO","assistanceAvatar":"_3UBOPfd9wtDjmDuM","assistanceInfo":"_3qPHr4CxpUyeAEPe","assistanceTel":"_20tB4cdfq1wtzzTZ"};